var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3753 0.219407L6.00029 3.71941L1.62529 0.219407C1.52273 0.137331 1.40501 0.0762596 1.27884 0.03968C1.15268 0.00310046 1.02054 -0.00827106 0.889984 0.00621488C0.759425 0.0207008 0.632998 0.0607603 0.51792 0.124106C0.402843 0.187453 0.301369 0.272845 0.219293 0.375407C0.137217 0.477969 0.0761455 0.595694 0.039566 0.721858C0.00298638 0.848023 -0.00838506 0.980156 0.00610088 1.11072C0.0205868 1.24127 0.0606465 1.3677 0.123993 1.48278C0.187339 1.59786 0.272731 1.69933 0.375293 1.78141L5.37529 5.78141C5.55266 5.92341 5.77309 6.00078 6.00029 6.00078C6.2275 6.00078 6.44793 5.92341 6.62529 5.78141L11.6253 1.78141C11.8324 1.61565 11.9652 1.37439 11.9945 1.11072C12.0237 0.847039 11.9471 0.582541 11.7813 0.375407C11.6992 0.272845 11.5977 0.187453 11.4827 0.124106C11.3676 0.0607603 11.2412 0.0207008 11.1106 0.00621488C10.8469 -0.0230408 10.5824 0.0536468 10.3753 0.219407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.4bb6855b61d66fafcabfd44df21dfd6d.svg";
export { ForwardRef as ReactComponent };